import Cookies from 'js-cookie';

/** 화면 테마. system은 기기의 라이트/다크 설정을 따른다. */
export type Theme = 'light' | 'dark' | 'system';

const COOKIE_NAME = 'HYUNSUB_THEME';
const COOKIE_DOMAIN = 'hyunsub.kim';

export function readTheme(): Theme {
  const value = Cookies.get(COOKIE_NAME);
  return value === 'light' || value === 'dark' ? value : 'system';
}

/** `<html data-theme>`에 반영한다. hs·chat 토큰이 이 값을 보고 라이트/다크를 고른다(system이면 속성을 지운다). */
export function applyTheme(theme: Theme = readTheme()) {
  const root = document.documentElement;
  if (theme === 'system') {
    root.removeAttribute('data-theme');
  } else {
    root.setAttribute('data-theme', theme);
  }
}

/** 지금 다크로 보이는지(설정 → 기기 순). CSS로 못 칠하는 곳(지도 등)에서 쓴다. */
export function isDarkTheme(): boolean {
  const theme = readTheme();
  return theme === 'system' ? window.matchMedia('(prefers-color-scheme: dark)').matches : theme === 'dark';
}

/** 모든 서비스(<svc>.hyunsub.kim)가 같이 쓰도록 상위 도메인 쿠키로 굽고 바로 반영한다. */
export function saveTheme(theme: Theme) {
  const domain = window.location.hostname.endsWith(COOKIE_DOMAIN) ? COOKIE_DOMAIN : undefined;
  if (theme === 'system') {
    Cookies.remove(COOKIE_NAME, { domain, path: '/' });
  } else {
    Cookies.set(COOKIE_NAME, theme, { domain, path: '/', expires: 3650 });
  }
  applyTheme(theme);
}
